<template>
    <div>
        <app-text
            label="Name"
            :data-source="'deha.user.misc.socials.' + listitemId + '.data.name'"
            :data-preset="'Listpresets.socials'"
            required
            :maxlength="255"
        ></app-text>

        <app-text
            label="Link"
            :data-source="'deha.user.misc.socials.' + listitemId + '.data.link'"
            pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
            autoformat="url"
            required
            :maxlength="255"
        ></app-text>

        <!--
        <label>Icon</label>
        <img
            width="100"
            v-bind:src="
                generateMediaUrl({
                    id: getProp('deha.user.misc.socials.' + listitemId + '.data.icon.id'),
                    i: 1,
                    v: getActiveIconstyle,
                    w: 100
                })
            "
            alt=""
        />
        -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['generateMediaUrl', 'getProp', 'getActiveIconstyle'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R061'),
            help: this.$helpers.uiText('R062')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text
    }
};
</script>
